import { SlidersHorizontal } from 'lucide-react';
import { collections, fitnessCategories } from '../data/catalog';
import type { CollectionSlug } from '../types';

export type SortOption = 'recent' | 'low-price' | 'high-price' | 'best-sellers';

type Props = {
  collection: 'todos' | CollectionSlug;
  subcategory: string;
  sort: SortOption;
  size: string;
  color: string;
  availability: string;
  colors: string[];
  onCollection: (value: 'todos' | CollectionSlug) => void;
  onSubcategory: (value: string) => void;
  onSort: (value: SortOption) => void;
  onSize: (value: string) => void;
  onColor: (value: string) => void;
  onAvailability: (value: string) => void;
};

export function ProductFilters({ collection, subcategory, sort, size, color, availability, colors, onCollection, onSubcategory, onSort, onSize, onColor, onAvailability }: Props) {
  return <div className="filters-block">
    <div className="filter-tabs" role="group" aria-label="Coleção">
      <button className={collection === 'todos' ? 'is-selected' : ''} onClick={() => onCollection('todos')}>Todos</button>
      {collections.map((item) => <button key={item.slug} className={collection === item.slug ? 'is-selected' : ''} onClick={() => onCollection(item.slug)}>{item.name}</button>)}
    </div>
    {collection === 'fitness' && <div className="subfilter-tabs" role="group" aria-label="Categoria fitness">
      <button className={subcategory === 'todos' ? 'is-selected' : ''} onClick={() => onSubcategory('todos')}>Todos</button>
      {fitnessCategories.map((item) => <button key={item.slug} className={subcategory === item.slug ? 'is-selected' : ''} onClick={() => onSubcategory(item.slug)}>{item.name}</button>)}
    </div>}
    <div className="filter-selects" aria-label="Filtros avançados">
      <span><SlidersHorizontal size={17} /> Filtrar</span>
      <label>Ordenar por<select value={sort} onChange={(event) => onSort(event.target.value as SortOption)}><option value="recent">Mais recentes</option><option value="low-price">Menor preço</option><option value="high-price">Maior preço</option><option value="best-sellers">Mais vendidos</option></select></label>
      <label>Tamanho<select value={size} onChange={(event) => onSize(event.target.value)}><option value="todos">Todos</option>{['P', 'M', 'G', 'GG'].map((item) => <option key={item}>{item}</option>)}</select></label>
      <label>Cor<select value={color} onChange={(event) => onColor(event.target.value)}><option value="todos">Todas</option>{colors.map((item) => <option key={item}>{item}</option>)}</select></label>
      <label>Disponibilidade<select value={availability} onChange={(event) => onAvailability(event.target.value)}><option value="todos">Todas</option><option value="disponivel">Disponíveis</option><option value="esgotado">Esgotadas</option></select></label>
    </div>
  </div>;
}
